module.exports = __webpack_public_path__ + "static/media/wskb.695d8fdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/wskb.png
// module id = 427
// module chunks = 0